export default class AppSettings
{
    static readonly LOCAL_STORAGE_MOL_KEY = 'drawn_molfile_';
    static readonly LOCAL_STORAGE_SVG_KEY = 'drawn_svg_';
    static readonly MAIN = 'main';
    static readonly EXTRA = 'extra';
    static readonly HISTORY = 'history';
    static readonly SPECTRA = 'spectra';
};